import React, { useEffect, useState } from 'react';
import { dispatcher } from 'dispatcher';
import { get } from 'js/utils/fetch.util';
import { useAppSelector } from 'js/store/hooks';
import { Loader } from 'js/components/common/Loader';
import { mergeLeft, lensProp, over, assoc } from 'ramda';
import { withComponent } from 'js/components/hocs/withComponent';
import { componentService } from 'js/services/component.service';
import { path, pipe, omit, pick, compose } from 'js/utils/ramda.util';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as hooks from './hooks';
import * as helpers from './helpers';
import { FB_REGISTRATION } from './constants';

import style from './FacebookRegistration.scss';

const valuesMapping = {
    // eslint-disable-next-line camelcase
    first_name: 'firstname',
    // eslint-disable-next-line camelcase
    last_name: 'lastname',
    birthday: 'birthdate',
    // eslint-disable-next-line camelcase
    country_code: 'countrycode',
    region: 'state',
    gender: 'sex'
};

export const FacebookRegistrationBare = () => {
    const [isPlayerAccepted, acceptPlayer] = useState(false);
    const currentPage = encodeURIComponent(helpers.getCleanUrl());
    const { facebookClientID, facebookSuccessURL, facebookProxyURL } =
        useAppSelector(pick(['facebookClientID', 'facebookSuccessURL', 'facebookProxyURL']));
    const translate = useComponentTranslations();
    const fbLink = helpers.makeFbLink(facebookClientID, currentPage);
    const code = helpers.getPlayerAcceptedCode();
    const clearUrl = hooks.useClearUrl();

    useEffect(() => {
        if (code) {
            acceptPlayer(true);

            clearUrl();

            const proxyUrl = `${facebookProxyURL}?client_id=${facebookClientID}&redirect_uri=${currentPage}&code=${code}`;

            get(proxyUrl)
                .then((result) => {
                    const { access_token: accessToken } = result;
                    const graphUrl = helpers.makeGraphLink(accessToken);

                    return get(graphUrl);
                })
                .then((userInfo) => {
                    const location = path(['location', 'location'], userInfo);
                    const regInfo = pipe(
                        over(lensProp('birthday'), helpers.prepareBirthdate),
                        over(lensProp('gender'), helpers.prepareGender),
                        omit(['id', 'location']),
                        mergeLeft(location),
                        helpers.renameKeys(valuesMapping),
                        o => assoc('emailVerify', o.email, o)
                    )(userInfo);

                    dispatcher.dispatch('user:registrationInfo:fromFB', { regInfo, facebookSuccessURL });

                    acceptPlayer(false);
                })
                .catch(() => acceptPlayer(false));
        } else {
            clearUrl();
        }
    }, [code, currentPage, facebookClientID, facebookProxyURL, facebookSuccessURL, clearUrl]);

    return (
        <div className={style.wrapper}>
            {isPlayerAccepted
                ? <Loader />
                : (
                    <a className={`btn ${style.button}`} href={fbLink}>
                        <span className={style.logo} />
                        {translate('button')}
                    </a>
                )
            }
        </div>
    );
};

export const FacebookRegistration = compose(
    withComponent({
        tkPrefix: 'playtech.mobile.system.facebook-registration.'
    })
)(FacebookRegistrationBare);

componentService.registerPageComponents({ [FB_REGISTRATION]: FacebookRegistration });
componentService.registerWebContentComponents({ FacebookRegistrationButton: FacebookRegistration });
